import { CommandAttempt } from "./commandAttempt.model";
import { CommandState } from "./commandState.enum";
import { CommandStep } from "./commandStep.model";

export class CommandDetails {
  Id: string;
  Payload: string;
  ExecutedOn: Date;
  Title: string;
  Attempts: CommandAttempt[];
  Steps: CommandStep[];
  CommandState: CommandState;

  constructor(comm: {
    id?: string;
    payload?: string;
    executedOn?: Date;
    title?: string;
    attempts?: CommandAttempt[];
    steps?: CommandStep[];
    commandState: CommandState;
  }) {
    this.Id = comm.id;
    this.Payload = comm.payload;
    this.ExecutedOn = comm.executedOn;
    this.Title = comm.title;
    this.Attempts = comm.attempts;
    this.Steps = comm.steps;
    this.CommandState = comm.commandState;
  }
}
